<template>
  <el-dialog
    :visible.sync="show"
    :title="`预览`"
    width="600px"
    :close-on-click-modal="false"
  >
    <div class="d-flex center">
      <el-carousel height="265px" style="width: 500px;" indicator-position="outside">
        <el-carousel-item
          v-for="item in banners"
          :key="item.id">
          <el-image
            style="width: 100%;height:100%;"
            :src="item.image"
            fit="fill"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div slot="footer" class="d-flex right">
      <el-button
        size="small"
        @click="show = false"
      >关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getBanner
} from '@/api.js';
export default {
  name: 'BannerPreview',
  data() {
    return {
      show: false,
      banners: []
    }
  },
  methods: {
    open(locate, id) {
      // 打开方法，获取同位置所有轮播图，将当前图片放在第一个，之后进行轮播
      this.reset()
      this.getBanners(locate)
      .then(res => {
        if (res) {
          const thisItem = res.find(i => i.id === id)
          const banners = [ thisItem ].concat(res.filter(i => i.id !== id))
          
          this.banners = banners
        }
      })

      this.show = true
    },
    reset() {
      this.banners = []
    },
    getBanners(locate) {
      const query = {
        locate
      }

      return this.$request('get', getBanner, query)
    }
  }
}
</script>

<style>

</style>